import { render } from "./NewParticipantGrid.vue?vue&type=template&id=6cf4968a&scoped=true&ts=true"
import script from "./NewParticipantGrid.vue?vue&type=script&lang=ts"
export * from "./NewParticipantGrid.vue?vue&type=script&lang=ts"

import "./NewParticipantGrid.vue?vue&type=style&index=0&id=6cf4968a&scoped=true&lang=css"
import "./NewParticipantGrid.vue?vue&type=style&index=1&id=6cf4968a&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cf4968a"]])

export default __exports__